/* eslint-disable react/prop-types */
import Image from "next/image";

function ProductImage({ img, productName, width = 250, height = 175, className = "mx-auto" }) {
  return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
        maxWidth: "100%",
        overflow: "hidden",
        position: "relative",
      }}
      className={className}
    >
      <Image
        src={img?.src || "/images/no-image.jpg"}
        alt={img?.alt || productName}
        title={productName || "Product image"}
        fill
        sizes={`(max-width: 768px) 100vw, (max-width: 1200px) 50vw, ${width}px`}
        style={{ objectFit: "cover" }}
        quality={80}
        onError={(e) => {
          e.target.src = "/images/no-image.jpg";
        }}
      />
    </div>
  );
}

export default ProductImage;
